import getRequest from "util/APIHelperGet";
import patchRequest from "util/APIHelperPatch";
import { baseUrl } from "util/APIBaseUrl";

export const getEmployeesWithClockInStatus = async (customerId, params = {}) => {
  const { page, limit, search } = params;

  const queryParams = new URLSearchParams();
  if (page) queryParams.set("page", page.toString());
  if (limit) queryParams.set("limit", limit.toString());
  if (search) queryParams.set("search", search);

  const query = queryParams.toString();
  const response = await getRequest(`${baseUrl}/customer/${customerId}/workforce${query ? `?${query}` : ""}`);

  return response.payload;
};

export const getClockinSettings = async (customerId) => {
  const response = await getRequest(`${baseUrl}/customer/${customerId}/clockin-enablement-settings`);

  return response.payload;
};

export const updateClockinSettings = async (customerId, data) => {
  const response = await patchRequest({
    path: `customer/${customerId}/clockin-enablement-settings`,
    body: data,
    stringifyBody: true,
  });

  return response.payload;
};

export const getClockinHistory = async (customerId, employeeId, params = {}) => {
  const { page = 1, limit = 10 } = params;

  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });

  const response = await getRequest(
    `${baseUrl}/customer/${customerId}/employee/${employeeId}/clockin-enablement-history?${queryParams.toString()}`
  );

  return response.payload;
};

export const getEmployeeTimesheet = async (customerId, employeeId, params = {}) => {
  const { startDate, endDate, page = 1, limit = 20 } = params;

  const queryParams = new URLSearchParams({
    startDate,
    endDate,
    page: page.toString(),
    limit: limit.toString(),
  });

  const response = await getRequest(
    `${baseUrl}/customer/${customerId}/employee/${employeeId}/timesheet?${queryParams.toString()}`
  );

  return response.payload;
};
